import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-global-registry",
  "use": "icon-soc-global-registry-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"none\" id=\"icon-soc-global-registry\">\r\n  <!-- ???? Registry???? + ?? -->\r\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n    <rect x=\"192\" y=\"192\" width=\"640\" height=\"640\" rx=\"64\" />\r\n    <circle cx=\"512\" cy=\"416\" r=\"96\" />\r\n    <path d=\"M320 704c48-96 128-144 192-144s144 48 192 144\" />\r\n    <path d=\"M640 288l96 96 160-160\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-global-registry.svg
// module id = PbI3
// module chunks = 477